module.exports = "https://www.gc-pro.gnp.com.mx/1019dd79791f45bef5e458254e0c6239.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/acceso-compartido/03.png
// module id = 997
// module chunks = 0 1